import './styles.scss';

import React, {useEffect, useState} from 'react';

import { addStateHistory } from '../../utils/StateHistoryUtil';

export const NetworkStatus: React.FC = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => {
            addStateHistory('network-online');
            setIsOnline(true)
        };
        const handleOffline = () => {
            addStateHistory('network-offline');
            setIsOnline(false)
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (isOnline) {
        return null;
    }

    return (
        <div className='network-status-alert'>
            No internet connection. Please check your connection.
        </div>
    );
};
